module.exports = __webpack_public_path__ + "static/media/3.67928aea.jpg";